import { render, staticRenderFns } from "./ListResidents.vue?vue&type=template&id=3b29ee40&scoped=true&"
import script from "./ListResidents.vue?vue&type=script&lang=js&"
export * from "./ListResidents.vue?vue&type=script&lang=js&"
import style0 from "./ListResidents.vue?vue&type=style&index=0&id=3b29ee40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29ee40",
  null
  
)

export default component.exports